import './Herosection.css';

import React from 'react';
import Herosection from './Herosection';

function Home() {
    return (
        <React.Fragment>
            <Herosection />
        </React.Fragment>
    );
}
export default Home;